import { Dispatch, FC, ReactNode, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AccordionDetails, AccordionSummary } from '@mui/material';

import { NoTasks, StyledAccordion } from '@/features/orders/ui/Tasks/TasksList.styles';

interface TasksAccordionProps {
  label: string;
  tasks: any[];
  expanded: boolean;
  setExpanded: Dispatch<SetStateAction<boolean>>;
  renderTask: (task: any) => ReactNode;
  closeAll: () => void;
}

const TasksAccordion: FC<TasksAccordionProps> = ({
  label,
  tasks,
  expanded,
  setExpanded,
  renderTask,
  closeAll,
}) => {
  const { t } = useTranslation();

  return (
    <StyledAccordion
      expanded={expanded}
      onChange={() => {
        closeAll();
        setExpanded(!expanded);
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>{label}</AccordionSummary>
      <AccordionDetails sx={{ gap: '1rem' }}>
        {tasks.length > 0 ? (
          tasks.map((task) => renderTask(task))
        ) : (
          <NoTasks>{t('No tasks')}</NoTasks>
        )}
      </AccordionDetails>
    </StyledAccordion>
  );
};

export default TasksAccordion;
